import React, { useEffect, useMemo } from 'react';
import { Layout, Menu } from 'antd';
import {
  HomeOutlined,
  FileTextOutlined,
  TagsOutlined,
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AppFooter from '../Footer';
import AdminHeader from '../AdminHeader';
import '../../styles/AdminLayout.css';
import ChatbotWidget from '../Widgets/ChatbotWidget';
const { Sider, Content } = Layout;

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get current path
  const roleType = localStorage.getItem('roleType');

  // Redirect if the user does not have a valid role
  useEffect(() => {
    if (!roleType || (roleType !== 'ADMIN' && roleType !== 'EDITOR')) {
      navigate('/'); // Redirect to home if role is invalid
    }
  }, [roleType, navigate]);

  // Determine active menu key based on current route
  const activeMenuKey = useMemo(() => {
    const pathMap = {
      '/admin/home': 'home',
      '/admin/articles': 'articles',
      '/admin/categories': 'categories',
      '/admin/sub-categories': 'sub-categories',
      '/admin/users': 'users',
    };

    return pathMap[location.pathname] || 'home';
  }, [location.pathname]);

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case 'home':
        navigate('/admin/home');
        break;
      case 'articles':
        navigate('/admin/articles');
        break;
      case 'categories':
        navigate('/admin/categories');
        break;
      case 'sub-categories':
        navigate('/admin/sub-categories');
        break;
      case 'users':
        navigate('/admin/users');
        break;
      case 'logout':
        localStorage.removeItem('roleType');
        localStorage.clear();
        navigate('/login');
        break;
      default:
        break;
    }
  };

  // Render menu items based on roleType
  const getMenuItems = () => {
    if (roleType === 'ADMIN') {
      return (
        <>
          <Menu.Item key="home" icon={<HomeOutlined />}>
            Home
          </Menu.Item>
          <Menu.Item key="articles" icon={<FileTextOutlined />}>
            Articles
          </Menu.Item>
          <Menu.Item key="categories" icon={<TagsOutlined />}>
            Categories
          </Menu.Item>
          <Menu.Item key="sub-categories" icon={<TagsOutlined />}>
            Sub-Categories
          </Menu.Item>
          <Menu.Item key="users" icon={<UserOutlined />}>
            Users
          </Menu.Item>
          <Menu.Item key="logout" icon={<LogoutOutlined />}>
            Logout
          </Menu.Item>
        </>
      );
    }

    if (roleType === 'EDITOR') {
      return (
        <>
          <Menu.Item key="home" icon={<HomeOutlined />}>
            Home
          </Menu.Item>
          <Menu.Item key="articles" icon={<FileTextOutlined />}>
            Articles
          </Menu.Item>
          <Menu.Item key="logout" icon={<LogoutOutlined />}>
            Logout
          </Menu.Item>
        </>
      );
    }

    return null;
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider style={{ backgroundColor: '#fff' }}>
        <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <img src="/logo.png" alt="PROBONO Logo" className="logo-img" />
        </div>
        <Menu
          theme="light"
          mode="inline"
          selectedKeys={[activeMenuKey]} // Use selectedKeys instead of defaultSelectedKeys
          onClick={handleMenuClick}
        >
          {getMenuItems()}
        </Menu>
      </Sider>
      <Layout>
        <AdminHeader />
        <Content style={{ margin: '16px' }}>
          <div
            style={{
              padding: 24,
              background: '#fff',
              minHeight: 360,
            }}
          >
            {children}
            <Outlet />
          </div>
        </Content>
        <AppFooter />
        <ChatbotWidget />
      </Layout>
    </Layout>
  );
};

export default AdminLayout;